"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateDocumentAclSchema = void 0;
exports.updateDocumentAclSchema = {
    type: 'object',
    additionalProperties: {
        not: true,
        /* eslint-disable-next-line no-template-curly-in-string */
        errorMessage: '- should not have additional property ${0#}',
    },
    required: ['acl', 'documentID'],
    properties: {
        acl: {
            type: 'array',
            items: {
                type: 'string',
                errorMessage: 'should be a string',
            },
            errorMessage: 'should be an array of strings',
        },
        documentID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        },
    },
};
